import { render, staticRenderFns } from "./PictureArchive.vue?vue&type=template&id=228b1258"
import script from "./PictureArchive.vue?vue&type=script&lang=js"
export * from "./PictureArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports